var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEntregaProximidad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#124DBF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4892 37.5618C24.6797 37.5628 23.8899 37.3116 23.2297 36.843C22.5696 36.3745 22.0718 35.7119 21.8055 34.9474H29.1729C28.9066 35.7119 28.4088 36.3745 27.7487 36.843C27.0885 37.3116 26.2987 37.5628 25.4892 37.5618ZM16.3389 27.8703V21.8755C16.3389 17.6703 19.1951 14.1278 23.0644 13.0624C23.4474 12.0977 24.3833 11.418 25.4892 11.418C26.5951 11.418 27.531 12.0977 27.914 13.0624C31.7833 14.1291 34.6395 17.6703 34.6395 21.8755V27.8703L36.8709 30.1016C36.9925 30.2228 37.089 30.3669 37.1547 30.5255C37.2204 30.6841 37.2542 30.8541 37.2539 31.0258V32.333C37.2539 32.6797 37.1162 33.0122 36.871 33.2573C36.6259 33.5025 36.2934 33.6402 35.9467 33.6402H15.0317C14.685 33.6402 14.3525 33.5025 14.1074 33.2573C13.8622 33.0122 13.7245 32.6797 13.7245 32.333V31.0258C13.7242 30.8541 13.758 30.6841 13.8237 30.5255C13.8894 30.3669 13.9859 30.2228 14.1075 30.1016L16.3389 27.8703Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntregaProximidad);
export default __webpack_public_path__ + "static/media/entrega-proximidad.f1673e02cd265214b275c32042b22b3c.svg";
export { ForwardRef as ReactComponent };